// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__Wesbw","validationTips":"StatementDescriptor_validationTips__1P8iK"};